/** Single source of truth for legal copy across the site. */
export const LEGAL_ENTITY_NAME = 'Tracki LLP';
export const LEGAL_CONTACT_EMAIL = 'support@trackibuilds.com';
export const LEGAL_LAST_UPDATED = '17 May 2026';
export const LEGAL_GOVERNING_LAW = 'Singapore';
export const LEGAL_MIN_AGE = 13;
